import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export interface SystemSettings {
  maintenance_mode: boolean;
  announcement_banner: string;
  max_uploads_per_day: number;
}

export function useSystemSettings() {
  const [settings, setSettings] = useState<SystemSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Lắng nghe document 'global_config' trong collection 'system_settings'
    const unsub = onSnapshot(doc(db, "system_settings", "global_config"), (doc) => {
      if (doc.exists()) {
        setSettings(doc.data() as SystemSettings);
        console.log("🔥 Realtime Update:", doc.data());
      } else {
        console.log("No settings found");
      }
      setLoading(false);
    });

    // Cleanup listener khi component unmount
    return () => unsub();
  }, []);

  return { settings, loading };
}
